export default __webpack_public_path__ + "static/listing-page-be0bf3ea4fabf1db1a5b351f8b69242a.png";